import Markdown from 'react-markdown';
// import rehypeMathjax from 'rehype-mathjax';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/cjs/styles/prism';

const customStyle: {
  [key: string]: React.CSSProperties;
} = {
  ...oneDark,
  'pre[class*="language-"]': {
    ...oneDark['pre[class*="language-"]'],
    backgroundColor: '#111214',
    margin: 0,
  },
  'code[class*="language-"]': {
    ...oneDark['code[class*="language-"]'],
    backgroundColor: '#111214',
    margin: 0,
  },
};

export interface Message {
  content: string;
  isTyping?: boolean;
  hasFailed?: boolean;
}

const MarkdownText = ({ message }: { message: Message }) => {
  return (
    <div className='flex flex-col w-full'>
      <Markdown
        className="prose !prose-invert flex-1"
        remarkPlugins={[remarkGfm, remarkMath]}
        // rehypePlugins={[rehypeMathjax]}
        components={{
          code(props) {
            const { children, className, node, ...rest } = props;
            const match = /language-(\w+)/.exec(className || '');
            return match && match[1] ? (
              <div className="codeblock">
                <SyntaxHighlighter
                  children={String(children).replace(/\n$/, '')}
                  style={customStyle}
                  language={match[1]}
                />
              </div>
            ) : (
              <code {...rest} className={className}>
                {children}
              </code>
            );
          },
          table({ children }) {
            return (
              <table className="border-collapse border border-black px-3 py-1 dark:border-white">
                {children}
              </table>
            );
          },
          th({ children }) {
            return (
              <th className="break-words border border-black bg-gray-500 px-3 py-1 text-white dark:border-white">
                {children}
              </th>
            );
          },
          td({ children }) {
            return (
              <td className="break-words border border-black px-3 py-1 dark:border-white">
                {children}
              </td>
            );
          },
          a({ href, className, children }) {
            return (
              <a
                className={className}
                href={href}
                target="_blank"
                rel="noreferrer noopener"
              >
                {children}
              </a>
            );
          },
        }}
      >
        {message.content}
      </Markdown>
      {message.hasFailed ? (
        <div className="mt-1 text-error-red">
          Something went wrong. If this issue persists, please contact us.
        </div>
      ) : (
        <>{message.isTyping && <span className="inline-block w-[1px] h-[1.015rem] bg-white ml-[0.125rem] animate-cursor-blink"></span>}</>
      )}
    </div>
  );
};

export default MarkdownText;
